<template>
  <div class="layout layout--simple">
    <SimpleNav></SimpleNav>
    <Messages />
    <div class="layout__container">
      <div class="layout__content">
        <slot></slot>
      </div>
      <SimpleFooter :customerServiceData="customerServiceData"></SimpleFooter>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { onLoad } from '@/helpers/event'
import Messages from '@/components/_shared/Messages/Messages.vue'
import SimpleNav from '@/components/Navigation/SimpleNav/SimpleNav.vue'
import SimpleFooter from '@/components/Footer/SimpleFooter/SimpleFooter.vue'

export default {
  name: 'SimpleLayout',

  components: {
    SimpleNav,
    Messages,
    SimpleFooter,
  },

  computed: {
    ...mapGetters({
      customerServiceEmail: 'store/customerServiceEmail',
      customerServicePhone: 'store/customerServicePhone',
    }),

    customerServiceData() {
      return {
        email: this.customerServiceEmail,
        phone: this.customerServicePhone,
      }
    },
  },

  mounted() {
    onLoad().then(this.fetchData)
  },

  methods: {
    fetchData() {
      this.$store.dispatch('store/fetchData')
    },
  },
}
</script>

<style scoped lang="scss">
$simple-layout-container-top-margin: space(8);
$simple-layout-content-bottom-margin: space(16);

.layout {
  &__container {
    max-width: $mq-width-full;
    margin: 0 auto space(12);
    padding: 0 $site-gutter;

    @media ($mq-large) {
      padding: 0 $site-gutter-xlarge;
    }

    @media ($mq-larger) {
      margin-top: $simple-layout-container-top-margin;
      padding: 0 45px;
    }
  }

  &--bottom-margin &__container {
    margin-bottom: 100px;
    @media ($mq-larger) {
      margin-bottom: space(12);
    }
  }

  &__content {
    @media ($mq-large) {
      margin-bottom: $simple-layout-content-bottom-margin;
    }
  }
}
</style>
